/* eslint-disable consistent-return */
import * as React from "react";
import { useEffect, useState } from "react";
import { Button, DatePicker, Input, Row, Tooltip, Form } from "antd";
import moment from "moment";
import { ReactComponent as CancelButtonIcon } from "../../img/buttons_icons/cancelButton_icon.svg";
import { ReactComponent as SubmitButtonIcon } from "../../img/buttons_icons/submitButton_icon.svg";
import { ReactComponent as AddVersionIcon } from "../../img/versions_icons/addVersion_icon.svg";
import { ReactComponent as EditIcon } from "../../img/versions_icons/editVersion_icon.svg";
import { displayFormat, toDisplayFormat, toHttpFormatStartOfDay } from "../../lib/utils/formatDate";
import "../../styles/row.less";
import { checkIsLoaded, checkIsLoading } from "../../lib/utils/checkLoadingStatus";
import { hasAccess } from "../RolesModule/hasAccess";
import { MENU_ACCOUNT_ACCOUNTINFO_WRITE } from "../../lib/const/permissions";
import ToggleableVersionsTable from "../ToggleableVersionsTable/ToggleableVersionsTable";
import versionsTableUtils from "../../lib/utils/versionsTableUtils";
import { updateProperty } from "../../store/slices/properties";
import { fetchAccountPropertiesByOrgId, getPropertiesVersions } from "../../store/slices/accounts";
import { useAppDispatch, useAppSelector } from "../..";

export default function AccountPropertiesVersionsTable(props) {
  const { getPropertyVersions } = props;
  const {
    account,
    accountProperties,
    accountPropertiesLoading,
    propertyVersions,
    propertyVersionsLoading,
  } = useAppSelector((state) => state.accounts);

  const { tenantPropertiesDto } = useAppSelector((state) => state.tenants);
  const currentDate = moment();
  const dispatch = useAppDispatch();
  const [childTableData, setChildTableData] = useState([]);
  const [tableData, setTableData] = useState([]);
  
  const neededProperties = tenantPropertiesDto
    .filter((item) => item.propertyType.alias === "client.company_attributes")
    .map((item) => item.stringValue);

  const isChangingForbidden = versionsTableUtils.getIsTableChanging(childTableData);

  const [form] = Form.useForm();

  const handleSetInitialValue = (field) => {
    setTimeout(() => {
      form.setFieldsValue(field);
    }, 0);
  };

  console.log({ accountProperties });

  useEffect(() => {
    if (checkIsLoaded(accountPropertiesLoading)) {
      setTableData(
        accountProperties
          .filter((item) => neededProperties.includes(item?.propertyType?.alias))
          .map((item) => ({
            key: item?.propertyType?.alias,
            id: item?.propertyType?.alias,
            stringValue: item.stringValue,
            typeName: item?.propertyType?.name,
            fromDate: item.fromDate,
            toDate: item.toDate,
            propertyType: item?.propertyType,
          }))
      );
    }
  }, [accountPropertiesLoading, tenantPropertiesDto]);

  useEffect(() => {
    if (checkIsLoaded(propertyVersionsLoading)) {
      setChildTableData(
        propertyVersions[0]
          .map((version, i) => ({
            ...version,
            key: `${version.propertyType.alias}${version.fromDate}${version.toDate}`,
            id: version.id,
            typeName: version.propertyType.name,
            stringValue: version.stringValue,
            fromDate: version.fromDate,
            toDate: version.toDate,
            isCurrentVersion:
              moment(currentDate).isSameOrAfter(version.fromDate) &&
              moment(currentDate).isBefore(version.toDate),
            isPastVersion: moment(version?.toDate).isBefore(currentDate),
            isLatestVersion: propertyVersions[0].length === i + 1,
            isClosing: false,
            isCreated: false,
          }))
          .sort((a, b) => (moment(a.fromDate).isBefore(moment(b.fromDate)) ? 1 : -1))
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [propertyVersionsLoading]);

  const columnsWidths = {
    ...versionsTableUtils.columnsWidths,
    typeName: 200,
    stringValue: "",
  };

  const [columns, setColumns] = useState([
    {
      title: "Тип",
      dataIndex: "typeName",
      key: "typeName",
      width: columnsWidths.typeName,
    },
    {
      title: "Значение",
      dataIndex: "stringValue",
      key: "stringValue",
      width: columnsWidths.stringValue,
    },
    {
      title: "Период действия",
      key: "period",
      dataIndex: "period",
      width: columnsWidths.period,
      render: (text, record) =>
        `${toDisplayFormat(record.fromDate)} - ${toDisplayFormat(record.toDate)}`,
    },
    {
      title: "",
      dataIndex: "actions",
      width: columnsWidths.actions,
      key: "actions",
    },
    {
      dataIndex: "buttons",
      key: "buttons",
      width: columnsWidths.buttons,
      hidden: false,
    },
  ]);

  const validationLength = {
    INN: 10,
    KPP: 9,
  };

  const getChildColumns = () => [
    {
      title: "Тип",
      dataIndex: "typeName",
      key: "typeName",
      width: columnsWidths.typeName,
    },
    {
      title: "Значение",
      dataIndex: "stringValue",
      key: "stringValue",
      width: columnsWidths.stringValue,
      render: (text, record) => {
        if (record.isCreated || record.isEditing) {
          const regex = `^\\d{${validationLength[record.propertyType.alias]}}$`;

          const pattern = new RegExp(regex);
          const title = validationLength[record.propertyType.alias]
            ? `${record.propertyType.alias === "KPP" ? "КПП" : "ИНН"} состоит из ${
                validationLength[record.propertyType.alias]
              } цифр`
            : "";
          handleSetInitialValue({ stringValue: text });
          const onChange = (e) => {
            // const check = pattern.test(e.target.value);
          };
          return (
            <Tooltip
              // open={pattern.test(validateTooltip)}
              title={title}
            >
              <Form.Item
                name="stringValue"
                className="form-item-required__hidden-error__mb0"
                rules={
                  validationLength[record.propertyType.alias]
                    ? [{ required: true }, { pattern: pattern }]
                    : undefined
                }
              >
                <Input onChange={onChange} />
              </Form.Item>
            </Tooltip>
          );
        }
        return record.stringValue;
      },
    },
    {
      title: "Период действия",
      key: "period",
      dataIndex: "period",
      width: columnsWidths.period,
      render(text, record) {
        if (record.isCreated) {
          handleSetInitialValue({ fromDate: moment(record.fromDate).add(1, "day") });
          return (
            <>
              <Form.Item
                name="fromDate"
                className="form-item-required__hidden-error__mb0"
                rules={[{ required: true }]}
                style={{ display: "inline-block", marginRight: "5px" }}
              >
                <DatePicker
                  format={displayFormat}
                  allowClear={false}
                  disabledDate={(current) =>
                    current <= moment(record.fromDate) || current > moment(record.toDate)
                  }
                  // defaultPickerValue={moment(record.fromDate).add(1, "day")}
                />
              </Form.Item>
              <Form.Item
                style={{ display: "inline-block" }}
                className="form-item-required__hidden-error__mb0"
              >
                -{toDisplayFormat(record.toDate)}
              </Form.Item>
            </>
          );
        }
        if (record.fromDate && record.toDate) {
          return `${toDisplayFormat(record.fromDate)} - ${toDisplayFormat(record.toDate)}`;
        }
        return "";
      },
    },
    {
      title: "",
      dataIndex: "actions",
      key: "actions",
      width: 130,
      render: (value, record) => {
        if (hasAccess(MENU_ACCOUNT_ACCOUNTINFO_WRITE)) {
          if (record.isCreated || record.isEditing) {
            return (
              <Row>
                <Tooltip title="Подтвердить">
                  <Button
                    className="button-icon"
                    icon={<SubmitButtonIcon />}
                    type="text"
                    htmlType="button"
                    onClick={(e) => {
                      e.stopPropagation();
                      form.submit();
                    }}
                  />
                </Tooltip>
                <Tooltip title="Отменить">
                  <Button
                    className="button-icon"
                    icon={<CancelButtonIcon />}
                    type="text"
                    htmlType="button"
                    onClick={(e) => {
                      e.stopPropagation();
                      if (record.isEditing)
                        setChildTableData((prevState) =>
                          prevState.map((item) => {
                            if (item.isEditing) {
                              return { ...item, isEditing: false };
                            }
                            return item;
                          })
                        );
                      else {
                        setChildTableData((prevState) => prevState.filter((obj) => !obj.isCreated));
                      }
                      form.resetFields();
                    }}
                  />
                </Tooltip>
              </Row>
            );
          }
          return (
            <Row>
              <Tooltip title="Добавить версию">
                <Button
                  className="button-icon"
                  icon={<AddVersionIcon />}
                  type="text"
                  htmlType="button"
                  disabled={isChangingForbidden}
                  onClick={(e) => {
                    e.stopPropagation();
                    setChildTableData((prevState) =>
                      [
                        {
                          ...record,
                          key: "new_version",
                          fromDate: moment(record.fromDate).add(1, "seconds"),
                          isCreated: true,
                          isCurrentVersion: false,
                          isPastVersion: false,
                          isLatestVersion: false,
                        },
                        ...prevState,
                      ].sort((a, b) => (moment(a.fromDate).isBefore(moment(b.fromDate)) ? 1 : -1))
                    );
                  }}
                />
              </Tooltip>
              <Tooltip title="Редактировать версию">
                <Button
                  className="button-icon"
                  icon={<EditIcon />}
                  type="text"
                  htmlType="button"
                  disabled={isChangingForbidden}
                  onClick={(e) => {
                    e.stopPropagation();
                    setChildTableData((prevState) =>
                      prevState.map((item) => {
                        if (item.key === record.key) return { ...item, isEditing: true };
                        return item;
                      })
                    );
                  }}
                />
              </Tooltip>
            </Row>
          );
        }
      },
    },
    {
      title: "",
      dataIndex: "buttons",
      key: "buttons",
      width: columnsWidths.buttons,
      hidden: false,
    },
  ];

  const [childColumns, setChildColumns] = useState(getChildColumns());

  useEffect(() => {
    setChildColumns(getChildColumns());
  }, [isChangingForbidden]);

  const handleCreateVersion = async ({ fromDate }) => {
    const values = form.getFieldsValue();
    const newVersion = childTableData.find((item) => item?.isCreated || item?.isEditing);
    const isForceUpdate = !!newVersion?.isEditing;
    const versionDate = isForceUpdate
      ? newVersion.fromDate
      : toHttpFormatStartOfDay(moment(fromDate));

    await dispatch(
      updateProperty({
        id: newVersion.id,
        isVersionUpdated: isForceUpdate,
        fromDate: versionDate,
        values: {
          dateValue: newVersion.dateValue,
          fromDate: newVersion.fromDate,
          toDate: newVersion.toDate,
          id: newVersion.id,
          dsc: newVersion.dsc,
          propertyTypeAlias: newVersion?.propertyType?.alias,
          stringValue: values.stringValue,
        },
      })
    );
    await dispatch(
      getPropertiesVersions({
        propertiesArr: [account.organization.id],
        propType: newVersion.propertyType.alias,
      })
    );
    await dispatch(fetchAccountPropertiesByOrgId(account.organization.id));
  };

  return (
    <Form form={form} onFinish={handleCreateVersion}>
      <ToggleableVersionsTable
        tableName="organization-properties-table"
        columns={columns}
        setColumns={setColumns}
        childTableColumns={childColumns}
        setChildTableColumns={setChildColumns}
        tableData={tableData}
        childTableData={childTableData}
        isChildTableLoading={checkIsLoading(propertyVersionsLoading)}
        tableClassName="organization-properties-table"
        isPageable={false}
        isToggleableColumns={false}
        onOpenVersionsCallback={(record) => {
          getPropertyVersions([account.organization.id], record.propertyType.alias);
        }}
      />
    </Form>
  );
}
